import React from 'react';
import ArticleIntro from './ArticleIntro';
import ArticleKeyTakeaways from './ArticleKeyTakeaways';
import ArticleFAQ from './ArticleFAQ';
import ArticleReferences from './ArticleReferences';
import ArticleAuthor from './ArticleAuthor';
import ArticleTableOfContent from './ArticleTableOfContent';
import ArticleBlog from './ArticleBlog';
import RelatedProducts from '../RelatedProducts/RelatedProducts';
import ArticleSignup from './ArticleSignUp';
import ArticleAdditionalReading from './ArticleAdditionalReading';

interface ArticleDesktopLayoutProps {
  intro?: string;
  lastUpdatedDate?: string;
  keyTakeawaysContent?: object;
  isMobile: boolean;
  children?: React.ReactNode;
  faqContent?: object;
  activeIndex?: number;
  topicIndex?: number;
  references?: object;
  authorContent?: object;
  tableOfContent?: object;
  blogContent?: object;
  relatedProducts?: object[];
  onClickCallback?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isArticle?: boolean;
  rightArrowIconArticle?: any;
  leftArrowIconArticle?: any;
  signupContent?: object;
  relatedArticles?: object[];
}

const ArticleDesktopLayout: React.FC<ArticleDesktopLayoutProps> = ({
  intro,
  lastUpdatedDate,
  keyTakeawaysContent,
  isMobile,
  children,
  faqContent,
  activeIndex = 0,
  topicIndex = -1,
  references,
  authorContent,
  tableOfContent,
  blogContent,
  relatedProducts,
  onClickCallback,
  isArticle,
  rightArrowIconArticle,
  leftArrowIconArticle,
  signupContent,
  relatedArticles,
}) => {

  return (
    <div className="desktop-articlebody-section mx-auto flex w-full flex-col items-center pb-5 2xl:max-w-80p">
      <div className="flex justify-between px-2 py-3 lg:px-3h">
        <div className="desktop-articlebody-section-left w-7/12 lg:w-7/12 2lg:w-8/12 xl:w-8/12 2xl:w-8/12 3xl:w-8/12">
          {intro && (
            <ArticleIntro
              introContent={intro}
              lastUpdatedDate={lastUpdatedDate}
            />
          )}
          {keyTakeawaysContent && (
            <ArticleKeyTakeaways
              keyTakeawaysContent={keyTakeawaysContent}
              isMobile={isMobile}
            />
          )}
          <div className="articlebody-section md:py-3">{children}</div>
          {faqContent && (
            <ArticleFAQ
              faqContent={faqContent}
              activeIndex={activeIndex}
              topicIndex={topicIndex}
            />
          )}
          {references && <ArticleReferences references={references} />}
          {authorContent && <ArticleAuthor authorContent={authorContent} />}
        </div>
        <div className="desktop-articlebody-section-right w-5/12 pl-1 lg:w-5/12 lg:pl-7 2lg:w-4/12 xl:w-4/12 xl:pl-10 2xl:w-4/12 2xl:pl-15 3xl:w-4/12 3xl:pl-20">
          {tableOfContent && (
            <ArticleTableOfContent
              tableOfContent={tableOfContent}
              isMobile={isMobile}
            />
          )}
          {blogContent && (
            <ArticleBlog blogContent={blogContent} isMobile={isMobile} />
          )}
          {relatedProducts && relatedProducts.length > 0 && (
            <RelatedProducts
              products={relatedProducts}
              isMobile={!!isMobile}
              onClickCallback={onClickCallback || (() => {})}
              isArticle={!!isArticle}
              rightArrowIconArticle={rightArrowIconArticle}
              leftArrowIconArticle={leftArrowIconArticle}
            />
          )}
          {signupContent && <ArticleSignup signupContent={signupContent} />}
        </div>
      </div>
      {relatedArticles && relatedArticles.length > 0 && (
        <ArticleAdditionalReading
          articles={relatedArticles}
          isMobile={!!isMobile}
          rightArrowIconArticle={rightArrowIconArticle}
          leftArrowIconArticle={leftArrowIconArticle}
        />
      )}
    </div>
  );
};

export default ArticleDesktopLayout;